<template>
    <div class="card card-image" >
        <div class="card-inner">
            <slot name="action"></slot>
            <div class="image-container">
                <slot name="image"></slot>
            </div>
            <div class="content-container">
                <slot></slot>
            </div>
            <div class="select-marker">
                <i class="fa fa-check"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'cardImage',
        props: {},
        data: () => ({})
    }
</script>

<style lang="scss" scoped>

</style>
